import React, { useEffect } from "react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { useLocation } from "react-router-dom";

import { useOAuthToken } from "../api";

interface TelemetryComponentProps {
    appInsights: ApplicationInsights;
}

export const trackAppLoaded = (appInsights: ApplicationInsights, authRequired: boolean): void => {
    appInsights.trackEvent({
        name: "app.loaded",
        properties: {
            authRequired: String(authRequired),
            entryPath: window.location.pathname,
        }
    });
};

export const TelemetryUserContext: React.FC<TelemetryComponentProps> = ({ appInsights }) => {
    const userId = useOAuthToken();

    useEffect(() => {
        if (!userId) {
            appInsights.clearAuthenticatedUserContext();
            return;
        }

        appInsights.setAuthenticatedUserContext(userId);

        return () => {
            appInsights.clearAuthenticatedUserContext();
        };
    }, [appInsights, userId]);

    return null;
};

export const RouteTelemetry: React.FC<TelemetryComponentProps> = ({ appInsights }) => {
    const location = useLocation();

    useEffect(() => {
        appInsights.trackPageView({
            name: location.pathname === "/" ? "home" : location.pathname,
            uri: `${window.location.origin}${location.pathname}${location.hash}`,
            properties: {
                routePath: location.pathname,
            }
        });
    }, [appInsights, location.hash, location.pathname]);

    return null;
};
